import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

interface SectionImageProps {
  basis?: string;
}

export default styled.img<SectionImageProps>`
  width: 100%;
  object-fit: cover;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: ${({ basis }) => (basis ?? false ? basis : "50%")};

  @media screen and (min-width: ${DESKTOP}px) {
    width: ${({ basis }) => (basis ? basis : "50%")};
  }
`;
